export default function Stack() {
  return <section className="section" id="stack">
    <div className="section-head">
      <div>
        <p className="eyebrow">Technologies</p>
        <h2>The tools behind the build.</h2>
      </div>
      <p className="section-intro">A focused look at my stack, organized around the work your project needs.</p>
    </div>
    <div className="stack-grid">
      <div className="stack-group">
        <h3>Web &amp; mobile</h3>
        <div className="pills">
          <span className="pill">React</span>
          <span className="pill">Next.js</span>
          <span className="pill">TypeScript</span>
          <span className="pill">React Native</span>
          <span className="pill">Tailwind CSS</span>
        </div>
      </div>
      <div className="stack-group">
        <h3>APIs &amp; data</h3>
        <div className="pills">
          <span className="pill">Node.js</span>
          <span className="pill">Express</span>
          <span className="pill">Python</span>
          <span className="pill">PostgreSQL</span>
          <span className="pill">Supabase</span>
          <span className="pill">Stripe</span>
        </div>
      </div>
      <div className="stack-group">
        <h3>Cloud &amp; delivery</h3>
        <div className="pills">
          <span className="pill">AWS</span>
          <span className="pill">Lambda</span>
          <span className="pill">Docker</span>
          <span className="pill">GitHub Actions</span>
          <span className="pill">Vercel</span>
        </div>
      </div>
    </div>
    <p className="stack-note">Have an existing stack? Include it when you get in touch.</p>
  </section>;
}
